// extracted by mini-css-extract-plugin
export var chip = "_b7-0";
export var filterDropdown = "_b7-5";
export var filterItem = "_b7-6";
export var icon = "_b7-1";
export var removeButton = "_b7-3";
export var removeIcon = "_b7-4";
export var separator = "_b7-2";